import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorageCache, removeFromLocalStorageCache } from 'edcom-ui';

const CACHE_KEY = 'gdpr_v2';

const initialValue = {
  loading: true,
  inGdpr: null,
  gdprCookieDisabled: null,
  gdprCookieEnabled: null,
  refreshGDPRContext: () => {},
};

const GDPRContext = createContext(initialValue);

const GDPRProvider = ({ children }) => {
  const [gdprValue, setGDPR] = useState(initialValue);

  const loadInfo = async () => {
    const response = await fetch('/api/member/status_info', {
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query_string: {}, url: '/', csrfToken: '' }),
    });

    // If api call failed, assume not in GDPR
    if (!response.ok) {
      setGDPR({
        loading: false,
        inGdpr: false,
        gdprCookieDisabled: false,
        gdprCookieEnabled: true,
        refreshGDPRContext: () => {},
      });
    }

    // If json is badly formed, assume not in GDPR
    const json = await response.json();
    if (!json || !json.status || !json.result) {
      setGDPR({
        loading: false,
        inGdpr: false,
        gdprCookieDisabled: false,
        gdprCookieEnabled: true,
        refreshGDPRContext: () => {},
      });
    }

    const refresh = () => {
      try {
        // Clear cache
        removeFromLocalStorageCache(CACHE_KEY);

        loadInfo();
      } catch (e) {
        // Do nothing.
      }
    };

    setGDPR({
      loading: false,
      inGdpr: !!json.result.inGDPRCountry,
      gdprCookieDisabled: !!json.result.disabledCookieInGDPR,
      gdprCookieEnabled: !!json.result.enabledCookieInGDPR,
      refreshGDPRContext: refresh,
    });
  };

  // Get GDPR status from API on initial page load
  useLocalStorageCache(CACHE_KEY, initialValue, loadInfo);

  return (
    <GDPRContext.Provider value={gdprValue}>{children}</GDPRContext.Provider>
  );
};

GDPRProvider.displayName = 'GDPRProvider';
GDPRProvider.propTypes = {
  children: PropTypes.node,
};

export { GDPRContext as default, GDPRProvider };
